/*
 * Copyright (c) 2023 CalAmp Corp.  All Rights Reserved
 */
import isNumber from 'lodash.isnumber';
import {
  EntityTemplate,
  TemplateColumn,
  TemplateOperators,
  TemplateValidation
} from '../types/templates';
import {createValidation} from './TemplateHelpers';

/**
 * Provides a utility function which manages the dynamic generation of an XLSX
 * spreadsheet specific to role identifier imports for download by the User.
 */
export const rolesTemplate = ({columns, options = {}}: EntityTemplate) => {
  const columnEntries: TemplateColumn[]     = [];
  const columnValidations: TemplateValidation[] = [];
  const templateColumns = {};
  columns.forEach((column, index) => {
    const {key, type, required, max, min, error, width, style} = column;
    const validation = createValidation({required, error, index, type});
    const {header} = column;
    if (error) {
      if (isNumber(max) && required) {
        validation.formulae = [1, max];
        validation.operator = TemplateOperators.Between;
      } else if (isNumber(max)) {
        validation.formulae = [max];
        validation.operator = TemplateOperators.LessThanOrEqual;
      } else if (isNumber(min)) {
        validation.formulae = [min];
        validation.operator = TemplateOperators.GreaterThanOrEqual;
      }
    }
    columnEntries.push({key, header, width, style});
    columnValidations.push(templateColumns[key]?.({column, validation, options}) || validation);
  });
  return {
    columnEntries,
    columnValidations
  };
};
